import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import locationzoomeffect from "./../Dashboard/Images/locationzoomeffect.png";
import locationzoomeffect1 from "./../Dashboard/Images/locationzoomeffect1.png";
import locationzoomeffect2 from "./../Dashboard/Images/locationzoomeffect2.png";
// Fix for default marker icons in Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: locationzoomeffect,
  iconUrl: locationzoomeffect1,
  shadowUrl: locationzoomeffect2,
});

const PropertyMapWithZoom = () => {
  const [properties, setProperties] = useState([]);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(5);

  // Function to determine color based on creation date
  const getColorByCreationDate = (createdDate) => {
    const created = new Date(createdDate);
    const now = new Date();
    const timeDiff = now - created;
    const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
    
    if (daysDiff <= 90) { // 3 months = ~90 days
      return '#4CAF50'; // Green for properties <= 3 months
    } else if (daysDiff <= 180) { // 6 months = ~180 days
      return '#FFC107'; // Amber for properties <= 6 months
    } else {
      return '#F44336'; // Red for properties > 6 months
    }
  };

  // Create simple dot marker
  const createDotIcon = (createdDate) => {
    const color = getColorByCreationDate(createdDate);
    return L.divIcon({
      className: 'dot-marker',
      html: `<div style="
        background: ${color};
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 1px solid white;
        box-shadow: 0 0 3px rgba(0,0,0,0.3);
      "></div>`,
      iconSize: [10, 10],
      iconAnchor: [5, 5]
    });
  };

  // Create price label marker
  const createPriceIcon = (price, createdDate) => {
    const priceText = price >= 10000000 
      ? `₹${(price/10000000).toFixed(1)}Cr` 
      : price >= 100000 
        ? `₹${(price/100000).toFixed(1)}L` 
        : `₹${price.toLocaleString()}`;

    const color = getColorByCreationDate(createdDate);

    return L.divIcon({
      className: 'price-marker',
      html: `<div style="
        background: ${color};
        color: white;
        padding: 2px 6px;
        border-radius: 12px;
        font-size: 10px;
        font-weight: bold;
        white-space: nowrap;
        box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        border: 1px solid white;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 20px;
        height: 20px;
      ">${priceText}</div>`,
      iconSize: [null, null],
      iconAnchor: [10, 10]
    });
  };

  // Update markers based on zoom level
  const updateMarkers = () => {
    if (!map || properties.length === 0) return;

    // Clear existing markers
    markers.forEach(marker => map.removeLayer(marker));
    
    // Add new markers with appropriate icons
    const newMarkers = properties.map(property => {
      if (property.lat && property.long && property.created_at) {
        const icon = zoomLevel >= 10 
          ? createPriceIcon(property.price, property.created_at)
          : createDotIcon(property.created_at);
        
        return L.marker([parseFloat(property.lat), parseFloat(property.long)], {
          icon
        }).addTo(map);
      }
      return null;
    }).filter(marker => marker !== null);

    setMarkers(newMarkers);
  };

  useEffect(() => {
    // Fetch data from API
    const fetchProperties = async () => {
      try {
        const response = await fetch('https://landnest.net:81/property/');
        if (!response.ok) {
          throw new Error('Failed to fetch properties');
        }
        const data = await response.json();
        setProperties(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  useEffect(() => {
    if (!map && !loading && !error) {
      // Initialize map centered on India
      const mapInstance = L.map('map').setView([20.5937, 78.9629], 5);

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(mapInstance);

      // Track zoom level changes
      mapInstance.on('zoomend', () => {
        setZoomLevel(mapInstance.getZoom());
      });

      setMap(mapInstance);
    }
  }, [loading, error, map]);

  useEffect(() => {
    updateMarkers();
  }, [map, properties, zoomLevel]);

  if (loading) {
    return <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center' 
    }}>
      Loading property data...
    </div>;
  }

  if (error) {
    return <div style={{ 
      width: '100%', 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      color: 'red'
    }}>
      Error: {error}
    </div>;
  }

  return (
    <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <div id="map" style={{ width: '100%', height: '100%' }}></div>
      
      {/* Search and filter controls */}
      <div style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        zIndex: 1000,
        width: '300px'
      }}>
        <input 
          type="text" 
          placeholder="Search location..." 
          style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            marginBottom: '10px'
          }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <button style={{ padding: '8px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '4px' }}>
            Buy Properties
          </button>
          <button style={{ padding: '8px', backgroundColor: '#f0f0f0', border: 'none', borderRadius: '4px' }}>
            PLOT/LAND
          </button>
        </div>
      </div>
      
      {/* Legend */}
      <div style={{
        position: 'absolute',
        bottom: '20px',
        right: '20px',
        backgroundColor: 'white',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
        zIndex: 1000,
        fontSize: '12px'
      }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>Property Age</div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '3px' }}>
          <div style={{ width: '12px', height: '12px', backgroundColor: '#4CAF50', borderRadius: '50%', marginRight: '5px' }}></div>
          {/* ≤ 3 months */}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '3px' }}>
          <div style={{ width: '12px', height: '12px', backgroundColor: '#FFC107', borderRadius: '50%', marginRight: '5px' }}></div>
          {/* ≤ 6 months */}
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '12px', height: '12px', backgroundColor: '#F44336', borderRadius: '50%', marginRight: '5px' }}></div>
          {/* > 6 months */}
        </div>
      </div>
    </div>
  );
};

export default PropertyMapWithZoom;